import { ComponentStyle } from '@blockanalitica/ui/package/types/src/theme/types';

export function kpiBody(): ComponentStyle {
  return {
    componentName: 'kpiBody',
    baseStyle: {
      fontWeight: 300
    }
  };
}
